import { SwitchPlatformsMeta, SwitchPlatformsPayload } from 'types/store/SwitchPlatforms';
import { createAsyncReducer } from 'utils/Redux';

import { switchPlatformsActions } from '../actions';

export default createAsyncReducer<SwitchPlatformsMeta, SwitchPlatformsPayload>(switchPlatformsActions);
